import type { SVGProps } from 'react';

/** '이미 가입된 치과' 안내·가입 이메일 바꾸기 화면의 선 아이콘(시안 그대로, 24 격자 · 선 1.7) */
const Base = ({ children, strokeWidth = 1.7, ...rest }: SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" {...rest}>
        {children}
    </svg>
);

export const InfoIcon = (props: SVGProps<SVGSVGElement>) => (
    <Base {...props}><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" /></Base>
);

export const MailIcon = (props: SVGProps<SVGSVGElement>) => (
    <Base {...props}><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></Base>
);

export const ChatIcon = (props: SVGProps<SVGSVGElement>) => (
    <Base {...props}><path d="M12 4C7 4 3 7.1 3 11c0 2.3 1.4 4.3 3.6 5.6L6 20l3.8-2.2c.7.1 1.4.2 2.2.2 5 0 9-3.1 9-7s-4-7-9-7Z" /></Base>
);

export const PersonIcon = (props: SVGProps<SVGSVGElement>) => (
    <Base {...props}><circle cx="12" cy="8" r="4" /><path d="M4 20c1.5-3.5 4.4-5 8-5s6.5 1.5 8 5" /></Base>
);

export const ChevronRightIcon = (props: SVGProps<SVGSVGElement>) => (
    <Base {...props}><path d="m9 5 7 7-7 7" /></Base>
);

export const CheckIcon = (props: SVGProps<SVGSVGElement>) => (
    <Base strokeWidth={2.2} {...props}><path d="m5 12 4 4L19 6" /></Base>
);

export const ImageIcon = (props: SVGProps<SVGSVGElement>) => (
    <Base {...props}><rect x="3" y="4" width="18" height="16" rx="2" /><circle cx="9" cy="10" r="2" /><path d="m21 16-5-5-9 9" /></Base>
);

export const DocumentIcon = (props: SVGProps<SVGSVGElement>) => (
    <Base {...props}><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Z" /><path d="M14 3v5h5M9 13h6M9 17h4" /></Base>
);
